// This file is only a template for Stores.  Copy and paste this to your application store .ts file and start off from there
// Rename all things with App_Name.
// Naming convention for Stores is "[App Name]Store.ts" i.e. UserStore.ts, EntitlementStore.ts

import NodeEvents from 'events';
import CommonMessages from '../../../common/CommonMessages';
import assign from 'object-assign';
import UserProfileConstants from './../constants/UserLocaleConstants';
import Dispatcher from '../../../flux/AppDispatcher';
var AppDispatcher = Dispatcher.get(UserProfileConstants.LOCALE_DISPATCHER);


var EventEmitter = NodeEvents.EventEmitter;

var CHANGE_EVENT = 'UserLocale.change';
var _localeData: ILocaleData = getBlankLocale();
var _editLocaleData: ILocaleData = getBlankLocale();
var _hasChanges = false;
var _modalVisible = false;

function getBlankLocale(): ILocaleData {
    return {
        Cultures: [],
        TimeZones: [],
        UserLocale: null
    };
}

function setLocale(localeData: ILocaleData) {
    _localeData = localeData;
    _editLocaleData = $.extend({}, localeData);
    _hasChanges = false;    
}

function setLocalePreferences(localePreferences: ILocalePreferences) {
    _editLocaleData.UserLocale = localePreferences;
    _hasChanges = true;
}

var UserLocaleStore: IUserLocaleStore = assign({}, EventEmitter.prototype, {
    getLocale: function () {
        return _localeData;
    },
    getEditLocale: function () {
        return _editLocaleData;
    },
    getHasChanges: function () {
        return _hasChanges;
    },
    getModalVisible: function () {
        return _modalVisible;
    },
    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function (callback: any) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function (callback:any) {
        this.removeListener(CHANGE_EVENT, callback);
    }
});

AppDispatcher.register(function (payload:any) {
    switch (payload.actionType) {
        case UserProfileConstants.LOCALE_GET:
            setLocale(payload.locale);
            break;
        case UserProfileConstants.LOCALE_PREFERENCES_UPDATE:
            setLocalePreferences(payload.localePreferences);
            break;   
        case UserProfileConstants.LOCALE_CANCEL_CHANGES:
            setLocale(_localeData);
            break;       
        default: return true;
    }
    UserLocaleStore.emitChange();
    return true;
});

export default UserLocaleStore;